if (!customElements.get('koko-blur-explorer')) {
  customElements.define('koko-blur-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return; this._ready = true;
      const buttons = [...this.querySelectorAll('[data-zone]')];
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-zone]');
        if (!button || !this.contains(button)) return;
        this.dataset.active = button.dataset.zone;
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelectorAll('[data-zone-copy]').forEach(item => { item.hidden = item.dataset.zoneCopy !== button.dataset.zone; });
        this.querySelector('[data-zone-label]').textContent = button.querySelector('[data-zone-name]').textContent.toUpperCase();
        this.querySelector('[data-zone-number]').textContent = '0' + (buttons.indexOf(button) + 1) + ' / 03';
      });
    }
  });
}
if (!customElements.get('koko-finish-gallery')) {
  customElements.define('koko-finish-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return; this._ready = true;
      this._events = new AbortController();
      this._track = this.querySelector('.kle-days__track');
      this._slides = [...this.querySelectorAll('.kle-days__slide')];
      this._index = 0;
      this.querySelector('[data-gallery-prev]').addEventListener('click', () => this.go(-1), {signal:this._events.signal});
      this.querySelector('[data-gallery-next]').addEventListener('click', () => this.go(1), {signal:this._events.signal});
      this._track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault(); this.go(event.key === 'ArrowRight' ? 1 : -1);
      }, {signal:this._events.signal});
      this.observe();
    }
    observe() {
      this._observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.intersectionRatio > .65) {
            this._index = this._slides.indexOf(entry.target);
            this.querySelector('[data-gallery-count]').textContent = '0' + (this._index + 1) + ' / 02';
          }
        }
      }, { root: this._track, threshold: [.65] });
      this._slides.forEach(slide => this._observer.observe(slide));
    }
    go(direction) {
      this._index = Math.max(0, Math.min(this._slides.length - 1, this._index + direction));
      this._track.scrollTo({left:this._slides[this._index].offsetLeft - this._slides[0].offsetLeft, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    disconnectedCallback() { this._observer?.disconnect(); this._events?.abort(); this._ready = false; }
  });
}
if (!customElements.get('koko-line-erase-return')) {
  customElements.define('koko-line-erase-return', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return; this._ready = true;
      this.querySelector('[data-kle-buy]').addEventListener('click', event => {
        const target = [...document.querySelectorAll('form[action*="/cart/add"]')].find(form => form.getBoundingClientRect().height > 0);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'center'});
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex','-1');
        target.focus({preventScroll:true});
      });
    }
  });
}